const ENCODED_CONTROL_WHITESPACE = /%(?:25)*(?:09|0a|0c|0d)(?:%(?:25)*2f|\/)?/gi
const ENCODED_SPACE_PATH_BOUNDARY = /%(?:25)*20(?:%(?:25)*2f|\/)/gi
const ENCODED_LEADING_PATH_SEPARATOR = /^(https?:\/\/[^/?#\s]+)%(?:25)*2f/i
const RAW_URL_WHITESPACE = /[\t\n\f\r ]/g

export function normalizeAudioSourceUrl(value: string): string {
  return value
    .replace(ENCODED_SPACE_PATH_BOUNDARY, '/')
    .replace(ENCODED_CONTROL_WHITESPACE, (artifact) => (
      artifact.includes('/') || artifact.toLowerCase().includes('2f') ? '/' : ''
    ))
    .replace(ENCODED_LEADING_PATH_SEPARATOR, '$1/')
    .replace(RAW_URL_WHITESPACE, '')
    .trim()
}
